// extracted by css-extract-rspack-plugin
export default {"placeholderContainer":"placeholder-container--T5sFSm7etU5dQSfM"};